import React, { useState } from 'react';
import { PhotoDisplayData } from '../../types/PhotoDisplayData';
import { useSeasonsStore } from '../../stores/useSeasonsStore';
import './PhotoReorderButtons.css';

interface PhotoReorderButtonsProps {
  photo: PhotoDisplayData;
  photoIndex: number;
  totalPhotos: number;
}

export const PhotoReorderButtons: React.FC<PhotoReorderButtonsProps> = ({
  photo,
  photoIndex,
  totalPhotos
}) => {
  const { reorderPhotos, photosByEvent } = useSeasonsStore();
  const [isReordering, setIsReordering] = useState(false);

  const canMoveLeft = photoIndex > 0;
  const canMoveRight = photoIndex < totalPhotos - 1;

  const handleSwap = async (direction: 'left' | 'right') => {
    // Prevent multiple concurrent operations
    if (isReordering) {
      return;
    }

    setIsReordering(true);
    const currentPhotos = photosByEvent[photo.eventName].photos;
    const newPhotos = [...currentPhotos];

    const swapIndex = direction === 'left' ? photoIndex - 1 : photoIndex + 1;

    // Perform swap
    [newPhotos[photoIndex], newPhotos[swapIndex]] = [newPhotos[swapIndex], newPhotos[photoIndex]];

    try {
      await reorderPhotos(photo.eventName, newPhotos.map(p => p.id));
    } catch (error) {
      console.error('Failed to reorder photos:', error);
    } finally {
      setIsReordering(false);
    }
  };

  return (
    <div className="reorder-buttons">
      <button
        onClick={() => handleSwap('left')}
        disabled={!canMoveLeft || isReordering}
        title="Move left"
        className="reorder-btn"
      >
        ← Left
      </button>
      <button
        onClick={() => handleSwap('right')}
        disabled={!canMoveRight || isReordering}
        title="Move right"
        className="reorder-btn"
      >
        Right →
      </button>
    </div>
  );
};